// src/pages/portfolio/LandingPageCaseStudy.jsx
import { motion } from "framer-motion";
import landingImg from "../../assets/portfolio/landing.png"; // add your real image

export default function LandingPageCaseStudy() {
  return (
    <div className="w-full bg-transparent text-black pt-28 pb-24 px-6 md:px-20">

      {/* HERO SECTION */}
      <section className="mx-auto flex max-w-6xl flex-col items-center gap-10 text-center">

        {/* TEXT */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <h1 className="hero-heading mb-4">
            Landing Page Client Project
          </h1>

          <p className="hero-copy">
            A premium landing page designed for a SaaS startup,
            focusing on clarity, conversion, and a modern brand feel.
          </p>
        </motion.div>

        {/* IMAGE / MOCKUP */}
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="flex justify-center"
        >
          <img
            src={landingImg}
            alt="Landing Page"
            className="w-80 h-80 object-contain drop-shadow-xl"
          />
        </motion.div>

      </section>

      {/* FEATURES / HIGHLIGHTS */}
      <section className="mx-auto mt-24 max-w-6xl text-center">
        <h2 className="section-heading mb-10">
          Highlights
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {[
            "Modern UI with clean layout",
            "Conversion-focused hero section",
            "Consistent brand visuals",
            "Responsive for all screen sizes",
            "SEO-friendly structure",
            "Smooth animations & transitions"
          ].map((item, idx) => (
            <motion.div
              key={idx}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: idx * 0.1 }}
              className="glass-card rounded-[22px] p-6"
            >
              <h3 className="text-[16px] font-medium">{item}</h3>
            </motion.div>
          ))}
        </div>
      </section>

      {/* PROCESS */}
      <section className="mx-auto mt-32 max-w-6xl text-center">
        <h2 className="section-heading mb-10">
          Process
        </h2>

        <ul className="mx-auto max-w-3xl space-y-4 text-center text-[16px] leading-[1.7] text-neutral-700">
          <li>• Understanding client goals & brand vibe</li>
          <li>• Wireframing the page structure</li>
          <li>• Crafting the UI visual style</li>
          <li>• Interaction design & micro-animations</li>
          <li>• Building responsive layout</li>
        </ul>
      </section>

      {/* CTA */}
      <section className="mx-auto mt-32 max-w-6xl text-center">
        <h2 className="section-heading mb-6">
          Want a landing page like this?
        </h2>

        <a
          href="/contact"
          className="inline-block px-8 py-3 rounded-full bg-black text-white hover:bg-opacity-80 font-medium transition"
        >
          Let's Talk
        </a>
      </section>

    </div>
  );
}
